export function isProgramWidget(widgetId: string): boolean {
  return widgetId === 'ef4e59bd-625a-484e-9ba1-650d4aecf03b';
}
